
import { mdiCheck } from "@mdi/js";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      mdiCheck,

      datesClass: null, // v-custom-date-picker--straight || v-custom-date-picker--reverse

      tag: null,
      menu: false,
      dates: [],
      form: {
        districts: [],
        newsType: "all",
        district: "",
        gender: ["female"],
        profile_status: [],
      },
    };
  },

  computed: {
    ...mapGetters({
      filtersList: "profiles/getFiltersList",
      currentCity: "global/getCurrentCity",
    }),

    formattedDate() {
      if (this.dates.length === 2) {
        return `${this.dates[0]} - ${this.dates[1]}`;
      }
      return "Date range";
    },

    areaSelectOptions() {
      let districts = [
        {
          title: this.$t("all-areas"),
          value: "",
        },
      ];
      if (!this.filtersList || !this.filtersList.districts) {
        return [];
      }

      for (let i = 0; i < this.filtersList.districts.length; i++) {
        let district = this.filtersList.districts[i];
        let cityId = this.currentCity.id;
        if (district.city_id == cityId) {
          districts.push({
            title: district.title,
            value: "" + district.id,
          });
        }
      }

      return districts;
    },

    genderSelectOptions() {
      return [
        { title: this.$t("female"), value: "female" },
        { title: this.$t("male"), value: "male" },
        { title: this.$t("shemale"), value: "transgender" },
      ];
    },

    statusSelectOptions() {
      return [
        {
          title: this.$t("verified"),
          value: "verified",
        },
        {
          title: this.$t("has-quality-mark"),
          value: "quality mark",
        },
        {
          title: this.$t("verified"),
          value: "verified",
        },
        // {
        //   title: "Top",
        //   value: "top",
        // },
        {
          title: this.$t("awaiting-call"),
          value: "awaiting call",
        },
        {
          title: this.$t("pornstar"),
          value: "pornstar",
        },
      ];
    },

    selectList() {
      return [
        {
          placeholder: this.$t("area"),
          options: this.areaSelectOptions,
          filterName: "district",
        },
        {
          placeholder: this.$t("gender"),
          options: this.genderSelectOptions,
          filterName: "gender",
        },
        {
          placeholder: this.$t("status"),
          options: this.statusSelectOptions,
          filterName: "profile_status",
        },
      ];
    },
  },

  // watch: {
  //   dates: {
  //     handler(newVal) {
  //       if (newVal?.length <= 1) {
  //         this.datesClass = null;
  //       }
  //       if (newVal?.length === 2) {
  //         this.onDateChange(newVal[0], newVal[1]);
  //       }
  //     },
  //     immediate: true,
  //   },
  // },

  onMounted() {
    this.onFilterChange("male", "gender");
  },

  methods: {
    onFilterChange(value, filterName) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      this.$store.commit("updates/setFilters", {
        filterName,
        value,
      });

      this.$store.dispatch("updates/retrieveNews");
    },

    checkDates() {
      if (this.dates.length === 2) {
        this.menu = false;
        this.onDateChange(this.dates[0], this.dates[1]);

        this.$store.commit("updates/setDateFilter", this.dates);
        this.$store.dispatch("updates/retrieveNews");
      }
    },

    onDateChange(from, to) {
      const f = new Date(from);
      const t = new Date(to);

      if (f > t) {
        this.datesClass = "v-custom-date-picker--reverse";
      } else {
        this.datesClass = "v-custom-date-picker--straight";
      }
    },

    resetDates() {
      this.dates = [];
      this.menu = false;
      this.$store.commit("updates/setDateFilter", this.dates);
      this.$store.dispatch("updates/retrieveNews");
    },
  },
};
